// ./src/utils/api/AccountClosureService.ts
//
// ROADMAP A12.2 4b — what stops the signed-in account from closing (eventsmagic-api `accountCloseBlockers`; owner,
// 2026-10-15: no closing while future events hold tickets bought for real and not refunded). The Close-account drawer
// lists them before it asks for a password. ⚠ The drawer only INFORMS: ms_auth asks the same question itself before it
// closes anything, and refuses on blockers or on no answer.
import { gql } from "@apollo/client";
import { OpResult } from "@sdflc/api-helpers";

import { ApiService } from "./ApiService";

const BLOCKERS_QUERY = gql`
  query AccountCloseBlockers($params: AccountCloseBlockersInput) {
    accountCloseBlockers(params: $params) {
      code
      data { eventId kind title slug endsAt currencyCode paidCount unrefundedAmount }
      errors { name errors warnings }
    }
  }
`;

export interface AccountCloseBlocker {
  /** Null on the row about subscriptions (#288). */
  eventId: string | null;
  kind?: string | null;
  title?: string | null;
  slug?: string | null;
  /** When the event is over (ISO); null = not dated yet. */
  endsAt?: string | null;
  currencyCode?: string | null;
  /** Live ticket payments not yet fully refunded. */
  paidCount?: number | null;
  /** What is still unrefunded, in currencyCode. */
  unrefundedAmount?: number | null;
}

export class AccountClosureService {
  /** The signed-in account's blockers — empty = nothing stops it. Always fresh: a refund elsewhere changes it. */
  static async blockers(): Promise<OpResult> {
    return ApiService.executeQuery(BLOCKERS_QUERY, { params: {} }, { fetchPolicy: "network-only" });
  }
}
